export default "__VITE_ASSET__xfyOVamn__"